"use client"

import React, { createContext, useContext, useRef, useState } from "react";
import DialogContainer, { DialogOption } from "@/components/dialogs/DialogContainer";



const DialogContext = createContext<{
  openDialog: (title: string, content: React.ReactNode) => void;
  closeDialog: () => void;
}>({ openDialog: () => {}, closeDialog: () => {} });

export function useDialog() {
  return useContext(DialogContext);
}

export default function DialogProvider({ children }: { children: React.ReactNode }) {
  const [dialogs, setDialogs] = useState<DialogOption[]>([]);

  const openDialog = (title: string, content: React.ReactNode) => {
    const dialog: DialogOption = { title, content, open: true };
    setDialogs((prevDialogs) => [...prevDialogs, dialog]);
  };

  const closeDialog = () => {
    setDialogs((prevDialogs) => {
      const latestDialog = prevDialogs.pop();
      if (!latestDialog) return prevDialogs;
      if (latestDialog.onClose) latestDialog.onClose();
      return [...prevDialogs].concat({ ...latestDialog, open: false });
    });
  };

  const contextValue = useRef({ openDialog, closeDialog });

  return (
    <DialogContext.Provider value={contextValue.current}>
      {children}
      {dialogs.map((dialog, i) => (
        <DialogContainer key={i} {...dialog} />
      ))}
    </DialogContext.Provider>
  );
}
